module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud-sun-753f5d68a60ac825de38879b39fc55e5.svg";